/**
 * @prettier
 */
import { useState } from 'react';
import * as React from 'react';
import { Button } from 'src/components/Button';
import { translate } from 'src/i18n/translate';
import { AddTemporaryPreparationTimeDialog } from 'src/scenes/letseatmanager/preparationTime/AddTemporaryPreparationTimeDialog';

export function AddTemporaryPreparationTimeButton(): React.ReactElement {
    const [addTemporaryPreparationTimeDialogState, setAddTemporaryPreparationTimeDialogState] = useState({ open: false });

    const openAddTemporaryPreparationTimeDialog = () => setAddTemporaryPreparationTimeDialogState({ open: true });

    const closeAddTemporaryPreparationTimeDialog = () => setAddTemporaryPreparationTimeDialogState({ open: false });

    return (
        <div>
            <AddTemporaryPreparationTimeDialog open={addTemporaryPreparationTimeDialogState.open} onClose={closeAddTemporaryPreparationTimeDialog} />

            <Button secondary onClick={openAddTemporaryPreparationTimeDialog}>
                {translate('Rush Hour')}
            </Button>
        </div>
    );
}
